import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// Redux slices
import { setSubPage, setSubPage2 } from '../menu/menuSlice';
import { setUserId } from './settingsSlice';

// Components
import Max2SettingsAllotmentsLog from './allotments';
import Max2SettingsSystemData from './systemdata';
import Max2SettingsUsers from './users';
import Max2SettingsUserDetails from './userDetails';

// SemanticUI components
import { Segment, Label, Icon, Header, HeaderContent, Grid } from 'semantic-ui-react'

// Style
import './settings.css';




/**
 * 
 * @returns 
 */
const Max2Settings = () => {
  // local state
  const [activeSection, setActiveSection] = useState(null);
  const userId  = useSelector((state) => state.settings.userId);

  // global state
  const dispatch = useDispatch();

  // Section Users
  if (activeSection === 'Users') {
    if (userId) {
      return <Max2SettingsUserDetails userId={userId} />
    }
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Benutzerverwaltung</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { setActiveSection(null); dispatch(setSubPage(null)); dispatch(setUserId(null)) }} />
        </div>
        <Max2SettingsUsers />
      </Segment>
    )
  }

  // Section System Data
  if (activeSection === 'SystemData') {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Systemdaten</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { setActiveSection(null); dispatch(setSubPage(null)); dispatch(setSubPage2(null)) }} />
        </div>
        <Max2SettingsSystemData />
      </Segment>
    )
  }

  // Section Exports
  if (activeSection === 'Exports') {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Exporte</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => {setActiveSection(null); dispatch(setSubPage(null)) }} />
        </div>
      </Segment>
    )
  }

  // Section Allotments
  if (activeSection === 'Allotments') {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Allotments-Reqest-Log</span></Label>
        <div style={{position: 'absolute', top: '5px', right: '5px'}}>
          <Icon link size='large' name='times' onClick={() => { setActiveSection(null); dispatch(setSubPage(null)) }} />
        </div>
        <Max2SettingsAllotmentsLog />
      </Segment>
    );
  }

  return (
    <Segment textAlign='left' style={{margin: '25px', padding:'150px 50px 150px 50px'}}>
      <Grid>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='users' circular onClick={() => { setActiveSection('Users'); dispatch(setSubPage('Benutzerverwaltung')) }} />
            <HeaderContent>Benutzerverwaltung</HeaderContent>
          </Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='settings' circular onClick={() => { setActiveSection('SystemData'); dispatch(setSubPage('Systemdaten')) }} />
            <HeaderContent>Systemdaten</HeaderContent>
          </Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='download' circular onClick={() => { setActiveSection('Exports'); dispatch(setSubPage('Exporte')) }} />
            <HeaderContent>Exporte</HeaderContent>
          </Header>
        </Grid.Column>
        <Grid.Column width={4}>
          <Header as='h2' icon textAlign='center' style={{cursor: 'pointer'}}>
            <Icon name='history' circular onClick={() => { setActiveSection('Allotments'); dispatch(setSubPage('Allotments-Log')) }} />
            <HeaderContent>Allotments-Log</HeaderContent>
          </Header>
        </Grid.Column>
      </Grid>
    </Segment>
  )
}

export default Max2Settings;
